import React, { useState, useRef, useEffect } from 'react';
import { MdLogout } from 'react-icons/md';
import { TiArrowSortedDown } from 'react-icons/ti';

import { updateUserPassword, logOut } from '../../../services/userService';

import AdminMenuButton from '../buttons/AdminMenuButton/AdminMenuButton';
import ChangePasswordModal from '../modals/ChangePasswordModal/ChangePasswordModal';

import logo from '../../../images/logo/proLogo.png';

import './AdminTopBar.css';

const AdminTopBar = ({ currentUser, setCurrentUser }) => {
  const [isAdminMenuOpen, setIsAdminMenuOpen] = useState(false);
  const [isChangePasswordModal, setIsChangePasswordModal] = useState(false);
  const [changePasswordErrorMessage, setChangePasswordErrorMessage] =
    useState('');

  const menuRef = useRef();

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setIsAdminMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleToggle = () => setIsAdminMenuOpen((prev) => !prev);

  const onPasswordChangeClickHandler = () => {
    setIsAdminMenuOpen(false);
    setIsChangePasswordModal(true);
  };

  const onChangePasswordModalClose = () => {
    setChangePasswordErrorMessage('');
    setIsChangePasswordModal(false);
  };

  const handleSubmit = async (formData) => {
    if (formData.newPassword !== formData.confirmPassword) {
      setChangePasswordErrorMessage("New passwords don't match");
      return;
    }

    if (formData.newPassword.length < 6) {
      setChangePasswordErrorMessage(
        'New password must be at least 6 characters.',
      );
      return;
    }

    try {
      await updateUserPassword(currentUser._id, {
        currentPassword: formData.currentPassword,
        newPassword: formData.newPassword,
      });
      alert('Password changed successfully!');
      onChangePasswordModalClose();
    } catch (error) {
      const errorMessage = error.message.replace('newPassword', 'New password');
      setChangePasswordErrorMessage(errorMessage);
    }
  };

  //LOGOUT FUNCTION
  const handleLogOut = () => {
    logOut();
    setCurrentUser(null);
  };

  return (
    <div id='topbaradmin'>
      <div id='left-topbar'>
        <div className='topbar-logo-container'>
          <img className='topbar-logo' src={logo} alt='pro-evolution-logo' />
        </div>
      </div>

      <div id='right-topbar' ref={menuRef}>
        <button onClick={handleToggle} className='admin-topbar-right-btn'>
          {currentUser.image ? (
            <img
              className='topbar-user-image'
              src={currentUser.image}
              alt='pro-evolution user'
            />
          ) : (
            <div className='topbar-no-avatar'>
              <span>No Photo</span>
            </div>
          )}
          <div className='topbar-username'>{currentUser.userName}</div>
          <div className='topbar-down-arrow'>
            <TiArrowSortedDown />
          </div>
        </button>

        {isAdminMenuOpen && (
          <div className='admin-menu-container'>
            <AdminMenuButton onClickHandler={onPasswordChangeClickHandler}>
              Change password
            </AdminMenuButton>
            <AdminMenuButton onClickHandler={handleLogOut}>
              <MdLogout /> Logout
            </AdminMenuButton>
          </div>
        )}
        {isChangePasswordModal && (
          <ChangePasswordModal
            currentUser={currentUser}
            onClose={onChangePasswordModalClose}
            onSubmit={handleSubmit}
            errorMessage={changePasswordErrorMessage}
            setChangePasswordErrorMessage={setChangePasswordErrorMessage}
          />
        )}
      </div>
    </div>
  );
};

export default AdminTopBar;
